import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import CashBoxesReportPage from 'pages/private/admin/CashBoxesReportPage';
import EditCashBoxContext from 'contexts/EditCashBoxContext';
import CashBox from 'types/models/CashBox';
import CashBoxTransactionsListPage from 'pages/private/CashBoxTransactionsListPage';

export default ({ match }: RouteComponentProps): JSX.Element => {
  const [selectedCashBox, setSelectedCashBox] = React.useState<CashBox | null>(null);

  return (
    <EditCashBoxContext.Provider
      value={{
        selectedCashBox,
        setSelectedCashBox,
      }}
    >
      <Switch>
        <Route exact={true} path={`${match.url}`} component={CashBoxesReportPage} />
        <Route exact={true} path={`${match.url}/transactions`} component={CashBoxTransactionsListPage} />
      </Switch>
    </EditCashBoxContext.Provider>
  );
};
